import { render, staticRenderFns } from "./bxxmlc.vue?vue&type=template&id=53b8b15a"
import script from "./bxxmlc.vue?vue&type=script&lang=js"
export * from "./bxxmlc.vue?vue&type=script&lang=js"
import style0 from "./bxxmlc.vue?vue&type=style&index=0&id=53b8b15a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports